import { Reducer } from 'redux'
import { createFilter } from 'redux-persist-transform-filter'

import { ClosingsActionTypes, ClosingsState } from './types'

export const FILTER_PERSISTOR = createFilter(
  'closings',
  null,
  ['filterStatus'],
  'whitelist'
)

const INITIAL_STATE: ClosingsState = {
  error: '',
  filterStatus: [],
  list: [],
  loading: false,
  setStatusError: '',
  setStatusLoading: false,
  setStatusSuccess: '',
  total_results: 0
}

const reducer: Reducer<ClosingsState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    /**
     * GET_CLOSING
     */
    case ClosingsActionTypes.GET_CLOSINGS:
      return {
        ...state,
        filterStatus: payload.options.filterStatus,
        error: '',
        loading: true
      }
    case ClosingsActionTypes.GET_CLOSINGS_SUCCESS:
      return {
        ...state,
        list: payload.list,
        loading: false,
        total_results: payload.total_results
      }
    case ClosingsActionTypes.GET_CLOSINGS_FAILURE:
      return {
        ...state,
        error: payload.message,
        loading: false
      }

    /**
     * SET_CLOSING_STATUS
     */
    case ClosingsActionTypes.SET_CLOSING_STATUS:
      return {
        ...state,
        setStatusError: '',
        setStatusLoading: true,
        setStatusSuccess: ''
      }
    case ClosingsActionTypes.SET_CLOSING_STATUS_SUCCESS:
      return {
        ...state,
        setStatusLoading: false,
        setStatusSuccess: payload.message
      }
    case ClosingsActionTypes.SET_CLOSING_STATUS_FAILURE:
      return {
        ...state,
        setStatusError: payload.message,
        setStatusLoading: false
      }

    default:
      return state
  }
}

export default reducer
